import addError from '../../../utils/error.jsx';

export function request(userData) {
    return {
        type: 'STAFF_CREATE_REQUEST',
        userData
    };
}

export function error(errors) {
    addError(errors);

    return {
        type: 'STAFF_CREATE_ERROR',
        errors
    };
}

export function finish(userData) {
    return dispatch => {
        dispatch({
            type: 'STAFF_CREATE_FINISH',
            userData
        });

        dispatch({
            type: 'STAFF_QUERY_REQUEST'
        });
    };
}
